import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "./assets/css/style-page-modal.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import HeaderEn from "../detailpageVN/Page/component/headeren";
import FooterEn from "../detailpageVN/Page/component/footeren";

function ServerSignup() {
    const [isLoading, setIsLoading] = useState(true);
    // useEffect(() => {
    //     const handleMessage = (event) => {
    //         if (event.data.iframeHeight) {
    //             const iframe = document.getElementById('resizeIframe');
    //             if (iframe) {
    //                 iframe.style.height = event.data.iframeHeight + 'px';
    //             }
    //         }
    //     };

    //     window.addEventListener('message', handleMessage);
    //     return () => window.removeEventListener('message', handleMessage);
    // }, []);

    return (
        <div className="pageregistration">
            <HeaderEn />

            {/* {isLoading && (
                <div style={{
                    padding: '40px',
                    fontSize: '18px',
                    color: '#555',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="spinner-border text-primary" role="status"></div>
                    <div>Loading content, please wait...</div>
                </div>
            )} */}

            {/* Modal */}
            <iframe
                id="resizeIframe"
                src="https://hanbiro.vn/pages/en/server-hosting-signup"
                style={{ width: "100%", border: "none", height: "100vh" }}
                loading="eager"
                title="Cloud Service Signup"
                onLoad={() => setIsLoading(false)}
            />

            <FooterEn />
        </div>
    );
}

export default ServerSignup;
